var map = {
	"./dashboards/activity": 97,
	"./dashboards/activity.png": 97,
	"./dashboards/antibiotics": 98,
	"./dashboards/antibiotics.png": 98,
	"./dashboards/anticholinergics": 99,
	"./dashboards/anticholinergics.png": 99,
	"./dashboards/burden": 100,
	"./dashboards/burden.png": 100,
	"./dashboards/controlled": 101,
	"./dashboards/controlled.png": 101,
	"./dashboards/history_loader": 119,
	"./dashboards/history_loader.gif": 119,
	"./dashboards/insulins": 102,
	"./dashboards/insulins.png": 102,
	"./dashboards/monitoring": 103,
	"./dashboards/monitoring.png": 103,
	"./dashboards/omitted": 104,
	"./dashboards/omitted.png": 104,
	"./dashboards/opioid": 105,
	"./dashboards/opioid.png": 105,
	"./dashboards/parkinsons": 106,
	"./dashboards/parkinsons.png": 106,
	"./dashboards/performance": 107,
	"./dashboards/performance.png": 107,
	"./dashboards/pharmacy": 108,
	"./dashboards/pharmacy.png": 108,
	"./dashboards/prescribing": 109,
	"./dashboards/prescribing.png": 109,
	"./dashboards/probe": 110,
	"./dashboards/probe.png": 110,
	"./dashboards/safety": 111,
	"./dashboards/safety.png": 111,
	"./dashboards/stock": 112,
	"./dashboards/stock.png": 112,
	"./dashboards/usage": 113,
	"./dashboards/usage.png": 113,
	"./dashboards/vte": 114,
	"./dashboards/vte.png": 114,
	"./export": 120,
	"./export.svg": 120,
	"./logo": 71,
	"./logo-xs": 94,
	"./logo-xs.png": 94,
	"./logo.png": 71,
	"./logo.svg": 121,
	"./logo_text": 58,
	"./logo_text.jpg": 336,
	"./logo_text.png": 58,
	"./logo_text.svg": 337,
	"./user": 122,
	"./user.svg": 122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 335;